/**
 * Pill tabs switch panels. Each panel owns a shared <product-carousel>.
 */
if (!customElements.get('product-display-tab')) {
  class ProductDisplayTab extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this._onTabClick = this._onTabClick.bind(this);
      this.querySelectorAll('.pdt-tab').forEach((tab) => {
        tab.addEventListener('click', this._onTabClick);
      });
    }

    disconnectedCallback() {
      this.querySelectorAll('.pdt-tab').forEach((tab) => {
        tab.removeEventListener('click', this._onTabClick);
      });
      this._bound = false;
    }

    _onTabClick(event) {
      const tab = event.currentTarget;
      const index = Number(tab.dataset.tabIndex);
      if (!Number.isFinite(index)) return;
      this._activate(index);
    }

    _activate(index) {
      this.querySelectorAll('.pdt-tab').forEach((tab) => {
        const active = Number(tab.dataset.tabIndex) === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.querySelectorAll('.pdt-panel').forEach((panel) => {
        const active = Number(panel.dataset.panelIndex) === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      this.querySelectorAll('.gi-btn').forEach((btn) => {
        const active = Number(btn.dataset.tabIndex) === index;
        btn.classList.toggle('gi-btn-active', active);
      });

      const panel = this.querySelector(`.pdt-panel[data-panel-index="${index}"]`);
      const carousel = panel?.querySelector('product-carousel');
      if (carousel?.swiper) {
        requestAnimationFrame(() => {
          carousel.swiper.update();
          carousel.swiper.slideTo(0, 0);
        });
      }
    }
  }

  customElements.define('product-display-tab', ProductDisplayTab);
}
